import { useEffect, useState } from "react";
import axios from "axios";
import { Clock, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/social-planner`;
const DAYS = ["luni", "marți", "miercuri", "joi", "vineri", "sâmbătă", "duminică"];

export const BestTimeCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${API}/best-time`, { timeout: 60000 }).then((r) => setD(r.data)).catch(() => setD({ available: false, reason: "eroare" })); }, []);
  if (!d) return <div className="flex items-center gap-2 text-xs text-zinc-500"><Loader2 className="h-3.5 w-3.5 animate-spin" /> Analizez când reacționează clienții…</div>;
  if (!d.available) return <p className="text-xs text-zinc-500" data-testid="best-time-unavailable">Ora recomandată: încă nu sunt destule date ({d.reason}).</p>;
  const max = Math.max(...d.hours.map((h) => h.followers), 1);
  const better = !d.best.includes(d.current_hour);
  return (
    <div className="rounded-xl border border-zinc-800 bg-zinc-900/50 p-4" data-testid="best-time-card">
      <p className="flex items-center gap-2 text-sm font-medium text-zinc-100"><Clock className="h-4 w-4 text-amber-400" /> Ora recomandată: <span className="text-amber-300" data-testid="best-time-hours">{d.best.map((h) => `${h}:00`).join(", ")}</span></p>
      <p className="mt-1 text-xs text-zinc-400">
        Pe baza {d.source}{d.sample ? ` (${d.sample} interacțiuni)` : ""}. Acum postăm la 10:00{better && d.gain_pct ? ` — la ${d.best[0]}:00 sunt cu ~${d.gain_pct}% mai multe reacții` : better ? "" : " — e deja printre cele mai bune ore"}.
        {d.best_days?.length ? ` Cele mai active zile: ${d.best_days.map((x) => DAYS[x]).join(", ")}.` : ""}
      </p>
      <div className="mt-3 flex h-12 items-end gap-0.5">
        {d.hours.map((h) => (
          <div key={h.hour} title={`${h.hour}:00 — ${h.followers}`} className={`flex-1 rounded-t ${d.best.includes(h.hour) ? "bg-amber-400" : h.hour === 10 ? "bg-zinc-400" : "bg-zinc-700"}`} style={{ height: `${Math.max(4, (h.followers / max) * 100)}%` }} />
        ))}
      </div>
      <div className="flex justify-between text-[10px] text-zinc-500"><span>0:00</span><span>12:00</span><span>23:00</span></div>
    </div>
  );
};
